import Formulario from "../../../components/formulario"
import Layout from "../../../components/layout"

export default function MembrosCursos() {
  return (
    <Layout>
      <Formulario
        tituloFiltro={true}
        tituloFormulario='Membros Curso'
        atualizar={true}
        urlFiltroPesquisarPrincipal={''}
        urlFiltroPesquisarSegundario={''}
        tituloFiltroSelecoes={'Eventos'}
        identificador={'id'}
        alterar={true}
        cabecalhoDeRelatorios={["Nome", "Email", "Contato", "Sede", "Inscrição", "Ministério", "Tempo de CN"]}
        conteudoRelatorios={["nome", "email", "telefone", "nomesede", "inscricao", "ministeriodesejado", "observacoes"]}
        descOpcoesFiltro={"nomeevento"}
        descricaoDoFiltro='nome'
        exportar={true}
        filtrar={true}
        url={"https://logtech.solutions:9292/view/registro/curso"}
        cabeca={["Nome", "Email", "Contato", "Sede", "Inscrição", "Ministério", "Tempo de CN"]}
        conteudo={["nome", "email", "telefone", "nomesede", "inscricao", "ministeriodesejado", "observacoes"]}
        urlAlteracao={`https://logtech.solutions:9292/usuario`}
      />
    </Layout>
  )
}
